<ng-container *ngIf="data$ | async as data">
  <cx-generic-link
    *ngIf="data.locUrl; else nonLocUrl"
    [url]="data.locUrl"
    [style]="data.styleAttributes"
    [target]="getTarget(data)"
    >{{ data.linkName }}</cx-generic-link
  >
  <ng-template #nonLocUrl>
    <cx-generic-link [url]="data.url ?? ''" [style]="data.styleAttributes" [target]="getTarget(data)">{{
      data.linkName
    }}</cx-generic-link>
  </ng-template>
</ng-container>
